import React, { useState } from 'react'
import { LinkWrap } from '@truphone/gatsby-wrappers'
import { uppercaseString } from '@truphone/utils'

function Categories(props) {
  const [selected, setSelected] = useState(props.categories?.findIndex((x) => x.selected))

  return (
    <div className={`${props.dark ? 'text-white' : 'text-black'}  pt-8`}>
      <div className="container mx-auto px-2">
        <div className="w-full mx-auto overflow-x-auto pb-5 text-center">
          <div
            className={`flex-nowrap inline-flex justify-start xl:justify-center border ${
              props.dark ? 'border-white' : 'border-black'
            } rounded-lg mx-6`}
          >
            {props.categories &&
              props.categories.map((category, i) => {
                return (
                  <LinkWrap
                    key={`support-tab${i}`}
                    onClick={() => setSelected(i)}
                    href={category.href}
                    className={`tabs-border relative whitespace-nowrap px-4 md:px-6 xl:px-10 lg:px-5 py-2 md:py-3 xl:py-4 text-xs md:text-sm xl:text-base font-bold tracking-widest xl:tracking-xwidest text-center uppercase rounded-lg ${
                      selected === i
                        ? props.dark
                          ? 'z-1 is-active bg-blue-900'
                          : 'z-1 is-active bg-blue-100 text-white'
                        : ''
                    }`}
                  >
                    {uppercaseString(category.text)}
                  </LinkWrap>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Categories
